var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129.3 51.1",
    style: {
      enableBackground: "new 0 0 129.3 51.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2882A7;}\n\t.st1{fill:#333333;}\n\t.st2{fill:#E06E49;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.6,9.4h-9.1v25.5H9.1V9.4H0V3.1h24.6V9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.9,34.9h-6.3v-1.6c-1.1,1.2-3.1,2.1-5.4,2.1c-4.4,0-8.9-2.7-8.9-8.5c0-5.3,4.3-7.9,9.7-7.9 c2.2,0,3.6,0.5,4.6,1v-1.2c0-1.7-1.1-3-3.4-3c-2.9,0-4.4,0.4-6.5,1.6L25.2,13c2.8-1.6,5.1-2.4,8.9-2.4c5.8,0,9.7,3,9.7,8.4V34.9z  M37.6,27.9v-3c-1.1-0.7-2.1-1-4.4-1c-2.4,0-3.6,1.1-3.6,3c0,1.7,1,3.2,3.6,3.2C35.3,30.1,36.9,29,37.6,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69,30.1c-2.3,3.1-5,5.3-9.8,5.3c-6.2,0-11.2-5.1-11.2-12.4c0-7.3,4.8-12.4,11.4-12.4c4.5,0,7.4,2.2,9.4,5.3 L64.8,20c-1.4-2-2.9-3.4-5.4-3.4c-3,0-4.9,2.5-4.9,6.4c0,3.8,2,6.4,4.9,6.4c2.4,0,4-1.1,5.6-3L69,30.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.2,50.6c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.4,0.3-0.4 C94.1,50.2,94.2,50.4,94.2,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.4,50.2c-0.6,0.5-1.4,0.9-2.4,0.9c-1.6,0-3.2-1.3-3.2-4.1c0-2.7,1.6-4.1,3.2-4.1c1.1,0,1.7,0.4,2.3,0.8 l-0.2,0.2c-0.6-0.5-1.1-0.8-2.1-0.8c-1.5,0-2.8,1.3-2.8,3.8c0,2.5,1.3,3.8,2.8,3.8c0.9,0,1.6-0.3,2.2-0.8L101.4,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104,50.9h-0.3V40.2L104,40V50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,47c0,2.6-1.5,4.1-3.4,4.1c-1.9,0-3.4-1.4-3.4-4.1c0-2.6,1.5-4.1,3.4-4.1C111.5,42.9,113,44.4,113,47z  M112.6,47c0-2.5-1.3-3.8-3-3.8c-1.7,0-3,1.3-3,3.8s1.3,3.8,3,3.8C111.3,50.8,112.6,49.4,112.6,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.1,43.1h0.3v4.8c0,2.1,1,2.9,2.5,2.9c1.2,0,2.7-0.7,2.7-2.9v-4.8h0.3v7.8h-0.3v-1.7 c-0.3,1.2-1.4,1.9-2.7,1.9c-1.7,0-2.8-0.9-2.8-3.2V43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.1,50.9h-0.3v-1.4c-0.6,0.9-1.5,1.5-2.7,1.5c-1.7,0-2.9-1.2-2.9-4c0-2.9,1.2-4.1,3-4.1 c1.1,0,2,0.6,2.7,1.5v-4.2l0.3-0.2V50.9z M128.8,49.1v-4.3c-0.6-1-1.6-1.7-2.6-1.7c-1.7,0-2.7,1.2-2.7,3.8c0,2.6,1,3.8,2.7,3.8 C127.2,50.8,128.2,50.1,128.8,49.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.8,23.6l8.5-8.5l-4.7-4.7l-7.9,7.9c-3.1-4-6.8-7.7-12.4-7.7c-1.3,0-2.4,0.2-3.5,0.5 c-2.3,0.7-4.4,2-6.3,3.6v8.2c-2.8,2.1-5.9,4.3-8.8,5.9c-1.9,1-3.9,1.1-3.9-3.2v-8.5h5.8v-6.1h-5.8V1.8h0l-6.1,3.1v6.2h-4.1v6.1 h4.1V28c0,4.7,4.2,9.3,11.3,6.1c2.2-1,4.9-2.8,7.5-4.7v5.6h6.3V24.5V18v0c1.2-0.7,2.3-1.1,3.5-1.1c2.9,0,5.1,2.2,8,5.9l-8.1,8.1 l4.7,4.7l7.5-7.5c3.2,3.8,7,7.2,12.8,7.2v-6.2C125.7,28.9,123.3,26.7,120.8,23.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    className: "st2",
    width: 6.3,
    height: 7.6
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be1e884651de3e528920cda508993416.svg";
export { ForwardRef as ReactComponent };